import { apiRequest } from '../api/http'
import type { Warehouse, WarehousePayload } from './types'

const WAREHOUSES_BASE = '/api/warehouses'

function warehouseAuth(accessToken: string) {
  return { accessToken }
}

export function listWarehouses(accessToken: string): Promise<Warehouse[]> {
  return apiRequest<Warehouse[]>(WAREHOUSES_BASE, '', warehouseAuth(accessToken))
}

export function getWarehouse(accessToken: string, id: number): Promise<Warehouse> {
  return apiRequest<Warehouse>(WAREHOUSES_BASE, `/${id}`, warehouseAuth(accessToken))
}

export function createWarehouse(accessToken: string, payload: WarehousePayload): Promise<Warehouse> {
  return apiRequest<Warehouse>(WAREHOUSES_BASE, '', { method: 'POST', body: payload, accessToken })
}

export function updateWarehouse(accessToken: string, id: number, payload: WarehousePayload): Promise<Warehouse> {
  return apiRequest<Warehouse>(WAREHOUSES_BASE, `/${id}`, { method: 'PUT', body: payload, accessToken })
}

export function deleteWarehouse(accessToken: string, id: number): Promise<void> {
  return apiRequest<void>(WAREHOUSES_BASE, `/${id}`, { method: 'DELETE', accessToken })
}
